import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('article');
const GET_ARTICLES = define('GET_ARTICLES', true);
const GET_ARTICLE = define('GET_ARTICLE', true);
const CREATE_ARTICLE = define('CREATE_ARTICLE', true);
const UPDATE_ARTICLE = define('UPDATE_ARTICLE', true);
const PUBLISHED_ARTICLE = define('PUBLISHED_ARTICLE', true);
const DELETE_ARTICLE = define('DELETE_ARTICLE', true);

const initialState = {
  loadingArticles: true,
  articles: [],
  loadingArticle: true,
  article: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ARTICLES.PENDING:
      return {
        ...state,
        loadingArticles: true,
        articles: []
      };
    case GET_ARTICLES.RESOLVED:
      return {
        ...state,
        loadingArticles: false,
        articles: action.data
      };
    case GET_ARTICLES.REJECTED:
      return {
        ...state,
        loadingArticles: true,
      };
    case GET_ARTICLE.PENDING:
      return {
        ...state,
        loadingArticle: true,
        article: {}
      };
    case GET_ARTICLE.RESOLVED:
      return {
        ...state,
        loadingArticle: false,
        article: action.data
      };
    case GET_ARTICLE.REJECTED:
      return {
        ...state,
        loadingArticle: true
      };
    default: return state;
  }
};

export const actions = {
  loadArticles: () => ({
    type: GET_ARTICLES,
    promise: api.get('/articles')
  }),
  loadArticle: id => ({
    type: GET_ARTICLE,
    promise: api.get(`/articles/${id}`)
  }),
  createArticle: data => ({
    type: CREATE_ARTICLE,
    promise: api.post('/articles', data),
    success: 'Article has been created',
    error: 'Unable to create an article'
  }),
  updateArticle: (id, data) => ({
    type: UPDATE_ARTICLE,
    promise: api.put(`/articles/${id}`, data),
    success: 'Article has been updated',
    error: 'Unable to update an article'
  }),
  publishedArticle: (id, publish) => ({
    type: PUBLISHED_ARTICLE,
    promise: api.post(`/articles/${id}/publish`, { publish }),
    success: 'Article has been published',
    error: 'Unable to publish an article'
  }),
  deleteArticle: id => ({
    type: DELETE_ARTICLE,
    promise: api.delete(`/articles/${id}`),
    success: 'Article has been deleted',
    error: 'Unable to delete the article'
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/article.js